import { AutocompleteInput, BooleanField, Datagrid, FunctionField, List, ReferenceInput, SelectInput, TextField } from "react-admin";

export const QuestionList = (props) => {

    const filters = [
        <ReferenceInput label="Área" source="theme" reference="themes" sort={{ field: "name", order: "ASC" }} alwaysOn>
            <AutocompleteInput
                source="name"
                emptyText="Todos"
                clearAlwaysVisible={true}
                fullWidth
            />
        </ReferenceInput>,
        <SelectInput style={{ width: '250px' }} source="published_observations" label="Comentário publicado" emptyText="Todos" choices={[{ id: true, name: 'Possui comentário publicado' }, { id: false, name: 'Não possui comentário publicado' }]} alwaysOn />
    ];

    return (
        <List
            sort={{ field: 'source.name', order: 'ASC' }}
            filters={filters}
            exporter={false}
            bulkActionButtons={false}
            {...props}
        >
            <Datagrid rowClick={'edit'}>
                <TextField source="number" label="Número" />
                <FunctionField source="text" label="Enunciado" render={record => `${record.text.substring(0, 75) + "..."}`} />
                <BooleanField source="published_observations" label="Comentário publicado" />
                <TextField source="source.name" label="Fonte" />
                <TextField source="source.source_type.name" label="Tipo" />
                <TextField source="theme.name" label="Tema" />
            </Datagrid>
        </List>
    )
}